import axios, { CancelTokenSource } from 'axios';
import { SagaIterator } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';
import API from 'src/api';
import { UploadLogoType } from 'src/types/tenant';
import { SagaAction } from '../../types';
import { selectTenant } from '../selectors';
import { uploadTenantLogo } from '../actions';
import { setTenant } from '../reducers';

const uploadingTask: { source: CancelTokenSource | null } = {
  source: null,
};

function* tenantLogoUploadSaga({ payload }: SagaAction<Partial<UploadLogoType>>): SagaIterator {
  const tenant = yield select(selectTenant);

  try {
    yield put(uploadTenantLogo.pending());

    const source = axios.CancelToken.source();
    uploadingTask.source = source;

    const response = yield call(API.tenantLogoUpload, { ...payload, cancelToken: source.token });

    yield put(setTenant({ ...tenant, logoUrl: response.payload.logoUrl }));
    uploadingTask.source = null;
    yield put(uploadTenantLogo.success());
  } catch (error) {
    yield put(uploadTenantLogo.failure(error));
  }
}

export default tenantLogoUploadSaga;
